export class AtomicNodeView {
    constructor(node, view, getPos) {
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = null;
    }

    get contentDOM() {
        return null;
    }

    selectNode() {
        if (this.dom) {
            this.dom.classList.add("ProseMirror-selectednode");
        }
    }

    deselectNode() {
        if (this.dom) {
            this.dom.classList.remove("ProseMirror-selectednode");
        }
    }

    stopEvent() {
        return false;
    }

    ignoreMutation() {
        return true;
    }

    destroy() {}
}

